/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

.toast-container {
  inline-size: fit-content;
  background-color: var(--cpd-color-bg-action-primary-rest);
  color: var(--cpd-color-text-on-solid-primary);
  border-radius: 99px;
  padding: var(--cpd-space-2x) var(--cpd-space-4x);
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(--cpd-space-2x);
}

@media (forced-colors: active) {
  .toast-container {
    outline: 1px solid transparent;
  }
}

.icon {
  flex-shrink: 0;
}

.has-close {
  gap: var(--cpd-space-3x);
}

.content {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: var(--cpd-space-2x);
}

.close {
  align-self: flex-start;
  padding: var(--cpd-space-0-5x) !important;

  &:not(:hover, :focus-visible) {
    * {
      /* Override default color of icon button. The container background is different than the default canvas color */
      color: var(--cpd-color-icon-on-solid-primary) !important;
    }
  }
}
